// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"f2c98823","397":"d5fc3d81","549":"fb0f1bf9","842":"8999a5e3"}[chunkId] + ".chunk.css";
};